import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    command: '',
    attributes: {},
    content: ''
  }
});
